// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import RemoteModal from '../../modals/remote_modal'

up.compiler('.export-newsletter-subscribers-button', (element) => {
  element.addEventListener('click', (event) => {
    event.stopPropagation()
    event.preventDefault()
    new RemoteModal('/newsletter_subscriptions/export').open()
  })
})
